import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { Toaster } from "@/components/ui/toast";
import { rootSearchSchema } from "@/types/route-search-schemas";
import { RouterContext } from "@/types/router-context";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  validateSearch: rootSearchSchema,
})

function RootComponent() {
  return (
    <div className="flex flex-1 flex-col">
      <Outlet />

      <Toaster />
    </div>
  )
}
